<main>
  <div class="new-user-page shadow">
    <h5>New User</h5>
    <form [formGroup]="newUserForm" (ngSubmit)="createUser()" class="form">
      <section id="keycloak" class="keycloak-section form" [formGroup]="newUserForm.controls.keycloak" >
        <label for="keycloak" class="form-label">Keycloak Information</label>
        <div class="errors-wrapper">
          <label for="id" class="form-label">ID</label>
          <input type="text" class="form-control" id="id"
                 [formControl]="newUserForm.controls.keycloak.controls.id"
                 [class.invalid-input]="newUserForm.controls.keycloak.controls.id.errors">
          @if (newUserForm.controls.keycloak.controls.id.errors?.['required']) {
            <div class="input-error">
              ID is required
            </div>
          }
        </div>
  
        <div class="errors-wrapper">
          <label for="email" class="form-label">Email</label>
          <input type="email" class="form-control" id="email"
                 [formControl]="newUserForm.controls.keycloak.controls.email"
                 [class.invalid-input]="newUserForm.controls.keycloak.controls.email.errors">
          @if (newUserForm.controls.keycloak.controls.email.errors?.['required']) {
            <div class="input-error">
              Email is required
            </div>
          }
          @else if (newUserForm.controls.keycloak.controls.email.errors?.['email']) {
            <div class="input-error">
              Invalid Email
            </div>
          }
        </div>
  
        <div>
          <label for="username" class="form-label">Username</label>
          <input type="email" class="form-control" id="username"
                 [formControl]="newUserForm.controls.keycloak.controls.username">
        </div>

        <div id="keycloak-warning">
          <i class="fa-solid fa-triangle-exclamation warning"></i>
          <span id="keycloak-warning-text">
            This information should be filled in based on the user in Keycloak Dashboard
          </span>
        </div>
      </section>

      <div class="dropdown">
        <label for="tenant" class="form-label">Default Tenant</label>

        @if (!selectedTenant) {
          <div class="position-relative">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input id="tenant" type="text" class="form-control dropdown-toggle" spellcheck="false"
                   placeholder="Search" autocomplete="off" [formControl]="newUserForm.controls.tenantSearch"
                   (input)="filterSearchedTenants($event.target.value)" (focus)="showTenantsList = true"
                   [class.invalid-input]="newUserForm.controls.tenantSearch.errors">
          </div>
        }
        @else {
          <button type="button" id="tenant" class="form-control dropdown-toggle" (click)="showTenantsList = !showTenantsList">
            <div class="client-info">
              <i class="client-icon square-icon fa-duotone fa-solid fa-building-user"></i>
              <div class="client-name-description lh-1">
                <div class="d-flex">
                  <span class="client-name ellipsis">{{ selectedTenant.clientName }}</span>
                  <span class="client-description">{{ selectedTenant.clientDescription }}</span>
                </div>
                <div class="client-id">{{ selectedTenant.id }}</div>
              </div>
            </div>
          </button>
        }

        <ul id="tenants-list" class="dropdown-menu tenants-list w-100" [class.show]="showTenantsList">
          @if (selectedTenant) {
            <div class="position-relative px-g pb-g">
              <i class="fa-solid fa-magnifying-glass pb-g"></i>
              <input id="tenant" type="text" class="form-control" spellcheck="false"
                    placeholder="Search" autocomplete="off" [formControl]="newUserForm.controls.tenantSearch"
                    (input)="filterSearchedTenants($event.target.value)" (focus)="showTenantsList = true">
            </div>
          }

          @for (tenant of searchedTenants; track tenant) {
            <li>
              <button type="button" class="dropdown-item" [class.selected]="selectedTenant?.id === tenant.id"
                      (click)="selectTenant(tenant.id)" tabindex="0" role="menu">
                <div class="d-flex align-items-center g-g">
                  <div class="client-info flex-grow-1">
                    <i class="client-icon square-icon fa-duotone fa-solid fa-building-user"></i>
                    <div class="client-name-description">
                      <div class="d-flex">
                        <span class="client-name ellipsis">{{ tenant.clientName }}</span>
                        <span class="client-description">{{ tenant.clientDescription }}</span>
                      </div>
                      <div class="client-id">{{ tenant.id }}</div>
                    </div>
                  </div>

                  @if (selectedTenant?.id === tenant.id) {
                    <i class="fa-solid fa-circle-check primary"></i>
                  }
                </div>
              </button>
            </li>
          }
        </ul>
      </div>

      <div class="buttons-container">
        <button type="submit" class="btn btn-success" [disabled]="newUserForm.invalid || ongoingRequest">
          @if (ongoingRequest) {
            <i class="fa-solid fa-spinner rotating"></i>
          }
          @else {
            Save
          }
        </button>
      </div>
    </form>
  </div>
</main>
